module.exports = __webpack_public_path__ + "img/d8sj-btn.b4943de0.png";